import { useState, useEffect, useCallback } from "react";
import Web3 from "web3";
import { connect } from "react-redux";
import {
  accountUpdate,
  web3Loaded,
  updateProvider,
  accountUpdateOnDisconnect,
  clearProvider
  
} from "../../redux/actions";
import GeneralModal from "./wrongNetworkModal";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import clearData from "../../utils/clearData";

const AccountModal = ({
  accountUpdate,
  web3Loaded,
  updateProvider,
  providerInstance,
  accountUpdateOnDisconnect,
  account,
  clearProvider
}) => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("");
  const [currentAccount, setCurrentAccount] = useState(null);
  const [wrongNetwork, setWrongNetwork] = useState(false);

  let web3Modal = null;
  let web3 = null;
  let provider = null;

  // to initilize the web3Modal

  const init = async () => {
    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider,
        options: {
          rpc: {
            97: "https://data-seed-prebsc-1-s1.binance.org:8545/",
            56: "https://bsc-dataseed.binance.org/",
          },
          network: "binance",
        },
      },
    };

    web3Modal = new Web3Modal({
      network: "binance", // optional
      cacheProvider: false, // optional
      providerOptions, // required
    });
  };

  init();

  // action on connect wallet button

  const onConnect = async () => {
    //Detect Provider
    try {
      provider = await web3Modal.connect();
      if (provider.open) {
        await provider.open();
      }
      if (!provider) {
        setMessage("Please install MetaMask.");

        setTitle("Connect Wallet");

        setShow(true);
      } else {
        web3 = new Web3(provider);

        updateProvider({ provider: provider });

        web3Loaded({ web3: web3 });

        await ConnectWallet();
      }
    } catch (error) {
      console.log(error);
    }
  };

  // connect wallet

  const ConnectWallet = async () => {
    try {
      if (web3) {
        const chainId = await web3.eth.getChainId();

        if (chainId.toString() !== process.env.REACT_APP_CHAIN_ID) {
          onDisconnect().then(() => {
            setTitle("Wrong Network");

            setMessage(
              `Please select ${process.env.REACT_APP_NETWORK} network!`
            );

            setShow(true);
          });
        } else {
          // Get list of accounts of the connected wallet

          const accounts = await web3.eth.getAccounts();

          // MetaMask does not give you all accounts, only the selected account

          setCurrentAccount(accounts[0]);
        }
      }
    } catch (error) {
      if (error.message) {
        setMessage(error.message);

        setTitle("Connect Wallet");

        setShow(true);
      }
    }
  };

  //  disconnect wallet

  const onDisconnect = useCallback(async () => {
    setCurrentAccount(null);
    await accountUpdateOnDisconnect();
    await clearData();

    await clearProvider();

    if (web3Modal) await web3Modal.clearCachedProvider();

    provider = null;

    web3Modal = null;

    web3 = null;
    window.location.reload(true);
  }, [accountUpdateOnDisconnect]);

  // function to detect network change

  useEffect(() => {
    if (providerInstance && providerInstance.provider) {
      providerInstance.provider.on("chainChanged", async (chainId) => {
        const _chainId = parseInt(chainId, 16);
        if (_chainId.toString() !== process.env.REACT_APP_CHAIN_ID) {
          await onDisconnect();
        }
      });
    }
  }, [onDisconnect, providerInstance]);

  // function to detect account change

  useEffect(() => {
    if (providerInstance && providerInstance.provider) {
      providerInstance.provider.on(
        "accountsChanged",
        async function (accounts) {
          const id = await providerInstance.provider.request({
            method: "eth_chainId",
          });
          const chainId = parseInt(id, 16);
          if (
            chainId.toString() === process.env.REACT_APP_CHAIN_ID &&
            currentAccount &&
            window.sessionStorage.getItem("selected_account")
          ) {
            let formattedAccount = Web3.utils.toChecksumAddress(accounts[0]);

            await onDisconnect();

            await setCurrentAccount(formattedAccount);
          }
        }
      );
    }
  }, [currentAccount, providerInstance, onDisconnect]);

  // function to detect network change

  useEffect(() => {
    async function updateAccount() {
      window.sessionStorage.setItem("selected_account", currentAccount);
      await accountUpdate({ account: currentAccount });
    }
    if (currentAccount) {
      updateAccount();
    }
  }, [currentAccount, accountUpdate]);

  return (
    <>
      <button
        className="btn btn-text w-100-sm"
        // style={{ color: props.color }}
        onClick={account && account.account ? onDisconnect : onConnect}
      >
        {window.sessionStorage.getItem("selected_account")
          ? window.sessionStorage.getItem("selected_account").slice(0, 5) +
            "..." +
            window.sessionStorage.getItem("selected_account").slice(37, 42)
          : "Connect Wallet"}
      </button>
      {wrongNetwork ? (
        <GeneralModal
          title={"Wrong Network"}
          message={`Please choose ${process.env.REACT_APP_NETWORK} Network`}
          setShow={setWrongNetwork}
        />
      ) : null}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    account: state.account,
    providerInstance: state.provider,
  };
};

export default connect(mapStateToProps, {
  accountUpdate,
  web3Loaded,
  updateProvider,
  accountUpdateOnDisconnect,
  clearProvider
})(AccountModal);